import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ToggleButton.scss';

class ToggleButton extends Component {

	constructor(props) {
		super(props);
		this._id = ToggleButton.counter;
	}

	get id() {
		return this._id;
	}

	static get counter() {
		ToggleButton._counter = (ToggleButton._counter || 0) + 1;
		return ToggleButton._counter;
	}

	render(){
		return (
			<>
				<input
					type="checkbox"
					id={`toggle--${this._id}`}
					className="toggleButton"
					onChange={(e) => {
						this.props.onChange(e.target.checked);
					}}
					defaultChecked={this.props.defaultChecked}
				/>
				<label htmlFor={`toggle--${this._id}`} className="toggleLabel"></label>
			</>
		)
	}
}

ToggleButton.propTypes = {
	onChange: 				PropTypes.func.isRequired,
	defaultIsChecked:		PropTypes.bool
};

export default ToggleButton;